// format:
// {poll-hash: {answer_id: numFakeVotes}}

export const curatedPollsUids = [
  40, // Caimile Eager  // current events
  41, // Sam Diamond    // sports
  // 42, // Poppy Cadamom  // pop culture
];

export const baseline_votes = {
  'who-do-you-think-is-most-likely-to-die-in-prison-gxO5J39': {
    487: 4264, // Julian Assange
    488: 68, // Paul Manafort
    489: 2411, // Michael Avenatti
    490: 1347, // Roger Stone
    491: 7892, // Harvey Weinstein
    492: 2819, // Other
  },
};



// WEBPACK FOOTER //
// ./src/views/PollTemplate/boostVotes.js